export var BulkActionsSubjects;
(function (BulkActionsSubjects) {
    BulkActionsSubjects["ClearAllNotification"] = "toggle-clear-all-notification";
    BulkActionsSubjects["SelectAllNotification"] = "toggle-select-all-notification";
    BulkActionsSubjects["SuccessNotification"] = "bulk-success-notification";
    BulkActionsSubjects["FailNotification"] = "bulk-fail-notification";
})(BulkActionsSubjects || (BulkActionsSubjects = {}));
//# sourceMappingURL=bulkActions.js.map